<template>
  <div class="choose-box">
    <div class="title">当社のサービス</div>
    <div class="scroll-box">
      <div class="btn" @click="handlePlay">
        <span v-if="isPlay" class="iconfont icon-zanting"></span>
        <span v-else class="iconfont icon-bofang"></span>
      </div>
      <div @mouseover="handleMouseover" @mouseout="handleMouseout">
        <vue-seamless-scroll
          :key="key"
          :data="listData"
          :class-option="classOption"
          class="warp"
          ref="scroll"
        >
          <ul class="ul-item">
            <li class="li-item" v-for="(item, index) in listData" :key="index">
              <img class="bg" :src="item.src" />
              <!--              <img class="icon" :src="item.icon" />-->
              <div class="desc">{{ item.text }}</div>
            </li>
          </ul>
        </vue-seamless-scroll>
      </div>
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'

export default {
  name: 'ServiceSwiper',
  components: {
    vueSeamlessScroll
  },
  data() {
    return {
      listData: [
        {
          src: process.env.VUE_APP_FILE_URL + 'group-01.png',
          text: 'ショ-ト動画の管理·運用',
          icon: ''
        },
        {
          src: process.env.VUE_APP_FILE_URL + 'group-02.png',
          text: 'アフィリエイト管理',
          icon: ''
        },
        {
          src: process.env.VUE_APP_FILE_URL + 'group-03.png',
          text: 'ショップの運営と管理',
          icon: ''
        },
        {
          src: process.env.VUE_APP_FILE_URL + 'group-04.png',
          text: 'ライブ配信管理',
          icon: ''
        },
        {
          src: process.env.VUE_APP_FILE_URL + 'group-05.png',
          text: '広告運用サービス',
          icon: ''
        }
      ],
      classOption: {
        limitMoveNum: 2,
        direction: 2,
        step: 1,
        hoverStop: false
      },
      key: 0,
      isPlay: true
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.key = Math.random()
    },
    handleMouseover() {
      this.classOption.step = 0.5
    },
    handleMouseout() {
      this.classOption.step = 1
    },
    handlePlay() {
      if (this.isPlay) {
        this.$refs.scroll._cancle()
      } else {
        this.$refs.scroll._startMove()
      }
      this.isPlay = !this.isPlay
    }
  }
}
</script>

<style lang="scss" scoped>
.choose-box {
  background-color: $bg-color;
  padding: 30px 0 145px;
  .title {
    text-align: center;
    color: $text-color;
    font-weight: bold;
    font-size: 80px;
    line-height: 117px;
    margin-bottom: 47px;
  }
  .scroll-box {
    margin-top: 26px;
    .btn {
      margin-bottom: 40px;
      text-align: right;
      padding: 0 40px;
      .iconfont {
        color: $text-color;
        font-size: 36px;
        cursor: pointer;
        @media (max-width: $mobile-breakpoint) {
          font-size: 24px;
        }
      }
    }
    .warp {
      width: 280px * 4;
      //height: 260px;
      margin: 0 auto;
      //overflow: hidden;
      ul {
        list-style: none;
        padding: 0;
        margin: 0 auto;
        &.ul-item {
          display: flex;
          .li-item {
            width: 260px;
            //height: 260px;
            margin-left: 20px;
            color: #fff;
            //text-align: center;
            font-size: 30px;
            position: relative;
            .bg {
              width: 264px;
              //height: 387px;
              border-radius: 40px;
            }
            .icon {
              width: 64px;
              height: 64px;
              position: absolute;
              top: 42px;
              left: 34px;
            }
            .desc {
              color: #ffffff;
              font-weight: bold;
              font-size: 18px;
              letter-spacing: -0.2px;
              position: absolute;
              bottom: 23px;
              left: 34px;
              @media (max-width: $mobile-breakpoint) {
                font-size: 12px;
                bottom: 13px;
              }
            }
          }
        }
      }
    }
    @media (max-width: $mobile-breakpoint) {
      .warp {
        width: 200px * 2 !important;
        .li-item {
          width: 180px !important;
          .bg {
            width: 164px !important;
          }
        }
      }
    }
  }
}
</style>
